<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'edit'?'Edit': viewType == 'view'?'View':"" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span> 
                                </h2>
                        </div>
                        <span @click="$emit('close')"  class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                      <v-radio-group
                        :disabled="viewType === 'view'"
                        v-model="formData.active"
                        inline
                      >
                        <v-radio color="primary" label="Active" :value="1"></v-radio>
                        <v-radio color="error" label="Inactive" :value="0"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Exception <span style="color: red;">*</span></v-label>
                        
                        <TextFieldComponent  placeholder="Exception" :disabled="viewType === 'view'"
                            v-model="formData.exception" :rules="getRules('Exception')" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Title <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Title')" placeholder="Title" :disabled="viewType === 'view'" v-model="formData.title" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Author <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Author')"  placeholder="Author" :disabled="viewType === 'view'" v-model="formData.author" />
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Revision <span style="color: red;">*</span></v-label>
                    <DatePicker
                      :rules="getRules('Revision')"
                      v-model="formData.revision"
                      :placeholder="formData.revision"
                      :showReadOnly="viewType === 'view'"
                      @selectDate="forRevisionDate"
                    />                   
                    </v-col>
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Status <span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Status')"  placeholder="Status" :disabled="viewType === 'view'"
                            v-model="formData.status" />
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Courses Of Action <span style="color: red;">*</span></v-label>
                        <v-textarea variant="outlined" :rules="getRules('Courses Of Action')"  placeholder="Courses Of Action" :disabled="viewType === 'view'" v-model="formData.courses_of_action"></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end" v-if="viewType === 'edit'">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import DatePicker from "@/components/ui/DatePicker.vue";
import moment from "moment";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
        DatePicker,
    },
    data: () => ({
        formData: {
            exception:null,
            title:null,
            author:null,
            revision:null,
            status:null,
            courses_of_action:null,
            active:null,
            created:null,
            created_by:null,
            deleted:null,
            deleted_by:null,
        },
    }),
    props:['designation','customerForm','viewType','index'],
    created(){
        console.log(this.customerForm,"customerForm!!!!")
            this.formData.exception = this.customerForm.exception,
            this.formData.title = this.customerForm.title,
            this.formData.author = this.customerForm.author,
            this.formData.revision = this.customerForm.revision,
            this.formData.status = this.customerForm.status,
            this.formData.courses_of_action = this.customerForm.courses_of_action
            this.formData.active = this.customerForm.active
            this.formData.created = this.customerForm.created
            this.formData.created_by = this.customerForm.created_by
            this.formData.deleted = this.customerForm.deleted
            this.formData.deleted_by = this.customerForm.deleted_by
            this.formData.id = this.customerForm.id
        console.log(this.formData,'this.@@@')
    },
    
    methods:{
        moment,
        forRevisionDate(val) {
            this.formData.revision = moment(val).format('DD/MM/YYYY')
        },
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        async save() {
              const validation = await this.$refs.form.validate();
            if (!validation.valid) {
                console.log("Form not valid");
            } else {
                if(this.viewType == "edit"){
                this.$emit("update-location",this.formData,this.index,this.viewType)
                }
                // else{
                // this.$emit("save", this.formData,this.designation);
                // }
                this.formData = {};
                this.$emit("close");
            }
        },
    },
}

</script>

<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
</style>